export default {
  getNavigator: (model_type, model_uuid, data) => $nuxt.$axios.get($nuxt.$api.host + '/navigator/' + model_type + '/' + model_uuid, data),
}
